import React from 'react';

import { UserRoles } from '../types/User';
import { extractUserRole } from '../utils/User';

import { useAppSelector } from './reduxHooks';

export const useUserRole = () => {
  const { user } = useAppSelector((state) => state.model);
  const [userRole, setUserRole] = React.useState<UserRoles>(UserRoles.USER);

  React.useEffect(() => {
    if (user) setUserRole(extractUserRole(user));
  }, [user]);

  return {
    userRole,
  };
};
